import Vue from 'vue';
import Router from 'vue-router';
import VueRouter, { RouteConfig } from 'vue-router';
import {GlobalConstants} from '@/common/constants';
import RootViewer from './views/MainViewer/LeftViewer/organisms/RootViewer.vue';
import CategoryViewer from './views/MainViewer/LeftViewer/organisms/CategoryViewer.vue';
import DetailViewer from './views/MainViewer/LeftViewer/organisms/DetailViewer.vue';
import EditViewer from './views/MainViewer/LeftViewer/organisms/EditViewer.vue';
import LoginViewer from './views/MainViewer/LeftViewer/organisms/LoginViewer.vue';
import AccountViewer from './views/MainViewer/LeftViewer/organisms/AccountViewer.vue';
import PostCountManageViewer from './views/MainViewer/LeftViewer/organisms/PostCountManageViewer.vue';
import CategoryManageViewer from './views/MainViewer/LeftViewer/organisms/CategoryManageViewer.vue';
import SearchResultViewer from './views/MainViewer/LeftViewer/organisms/SearchResultViewer.vue';
import MenuViewer from './views/MainViewer/LeftViewer/organisms/MenuViewer.vue';
import AboutViewer from './views/MainViewer/LeftViewer/organisms/AboutViewer.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'route-viewer',
    component: RootViewer,
    meta: {
      title: '',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/c/:category/',
    name: 'category-viewer',
    component: CategoryViewer,
    meta: {
      title: '福岡の美容室 chiseiについて',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/c/:category/:id',
    name: 'detail-viewer',
    component: DetailViewer,
    meta: {
      title: '福岡の美容室 chiseiの記事',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/c/:category/edit/:id',
    name: 'edit-viewer',
    component: EditViewer
  },
  {
    path: '/s/:id',
    name: 'search-result-viewer',
    component: SearchResultViewer,
    meta: {
      title: '',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/account/:userName',
    name: 'account-viewer',
    component: AccountViewer,
    meta: {
      title: '福岡の美容室 chiseiについて',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: GlobalConstants.LOGIN.PATH,
    name: 'login-viewer',
    component: LoginViewer,
    meta: {
      title: '福岡の美容室 chiseiについて',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/menu/',
    name: 'menu-viewer',
    component: MenuViewer,
    meta: {
      title: '福岡の美容室 chisei メニュー',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/about/',
    name: 'about-viewer',
    component: AboutViewer,
    meta: {
      title: '福岡の美容室 chiseiについて',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  },
  {
    path: '/categorymanage/:userName',
    name: 'category-manage-viewer',
    component: CategoryManageViewer,
    meta: {
      title: '福岡の美容室 chiseiについて',
      desc: 'chiseiは福岡市内の大橋を拠点にしている美容室。'
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
